export const MM_EMPTY_DASH = '—';

export function orDash(value: string | number | null | undefined): string {
  if (value === null || value === undefined) {
    return MM_EMPTY_DASH;
  }

  const text = String(value).trim();

  return text === '' ? MM_EMPTY_DASH : text;
}

/** Ноль — корректная цена и печатается как 0.00; отсутствие цены выражается через null. */
export function formatMoney(value: number | null | undefined): string {
  if (value === null || value === undefined || isNaN(Number(value))) {
    return MM_EMPTY_DASH;
  }

  return Number(value).toFixed(2);
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) {
    return MM_EMPTY_DASH;
  }

  const date = new Date(value);

  if (isNaN(date.getTime())) {
    return String(value);
  }

  return date.toLocaleString();
}

export function formatDate(value: string | null | undefined): string {
  if (!value) {
    return MM_EMPTY_DASH;
  }

  const date = new Date(value);

  if (isNaN(date.getTime())) {
    return String(value);
  }

  return date.toLocaleDateString();
}

export function formatGroupCategoryLabel(
  groupName: string | null | undefined,
  categoryName: string | null | undefined,
): string {
  const group = groupName ? String(groupName).trim() : '';
  const category = categoryName ? String(categoryName).trim() : '';

  if (group !== '' && category !== '') {
    return group + ' — ' + category;
  }

  if (category !== '') {
    return category;
  }

  if (group !== '') {
    return group;
  }

  return MM_EMPTY_DASH;
}

export function formatLevelPath(
  groupName: string | null | undefined,
  categoryName: string | null | undefined,
  subcategoryName: string | null | undefined,
): string {
  const parts: string[] = [];

  if (groupName && String(groupName).trim() !== '') {
    parts.push(String(groupName).trim());
  }

  if (categoryName && String(categoryName).trim() !== '') {
    parts.push(String(categoryName).trim());
  }

  if (subcategoryName && String(subcategoryName).trim() !== '') {
    parts.push(String(subcategoryName).trim());
  }

  return parts.length === 0 ? MM_EMPTY_DASH : parts.join(' → ');
}

export function formatMonitoringSelectLabel(params: {
  createdAt: string | null | undefined;
  typeLabel: string;
  storeFormatName: string | null | undefined;
  storeRegionName: string | null | undefined;
  storeClusterName: string | null | undefined;
  isApproximate: boolean;
  approxLabel: string;
  fallback: string;
}): string {
  const parts: string[] = [];
  const created = formatDateTime(params.createdAt);

  if (created !== MM_EMPTY_DASH) {
    parts.push(created);
  }

  if (params.typeLabel !== '') {
    parts.push(params.typeLabel);
  }

  const zone = formatLevelPath(
    params.storeFormatName,
    params.storeRegionName,
    params.storeClusterName,
  );

  if (zone !== MM_EMPTY_DASH) {
    parts.push(zone);
  }

  if (params.isApproximate && params.approxLabel !== '') {
    parts.push(params.approxLabel);
  }

  return parts.length > 0 ? parts.join(' · ') : params.fallback;
}

export function truncate(value: string | null | undefined, maxLength: number): string {
  if (!value) {
    return MM_EMPTY_DASH;
  }

  const text = String(value);

  return text.length <= maxLength ? text : text.substr(0, maxLength - 1) + '…';
}
